import React, { Component } from "react";
import "./Statistics.css";
import axios from "../api/axios.js";
import Footer from "../Components/Footer.js";
import HomeNavbar from "../HomeNavbar.js";
import InfoTable from "../Components/InfoTable.js";
import { useState } from "react";
import { useEffect } from "react";
import SmallLoading from "../Components/smallLoading.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StatsBox from "../Components/StatsPage/StatsBox.js";
import { groupKingdoms, groupPlantaeSubgroups, groupTypesAndKingdoms, groupSpeciesByKingdom, calculateAminoAcidFrequency, computeEnzymeHistory } from "../functions/statisticsDataProcessing.js";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Legend } from 'recharts';
import { BarChart, Bar,  Rectangle, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { AreaChart, Area, ReferenceLine } from 'recharts';
import StackedAreaChart from "../Components/StatsPage/StackedKDEPlot.js";
import { constants } from "buffer";
import ResultInfoText from "../Components/ResultsTable/ResultInfoText.js";
import { Chart } from "react-google-charts";
import PageMenu from "../Components/PageMenu.js";



function Statistics(){
  const [stats, setStats] = useState(null)

  const colors = ['#006e00','#b24502','#ebac23','#ff9287','#5954d6','#b80058','#00c6f8', "#00FF00", '#8A6D3B']
  const kingdomColors = {
    Plantae: '#006e00',
    Fungi: '#b24502',
    Bacteria: '#ebac23',
    Animalia: '#ff9287',
    Amoebozoa: '#5954d6',
    Archaea: '#b80058',
    Viruses: '#00c6f8',
    Cyanobacteria: "#00FF00",
    Stramenopila: '#8A6D3B'
  };
  // Sub-groups of Plantae get their own single-hue green ramp so the chart
  // reads as a breakdown of the green "Plantae" slice above. Colours are keyed
  // by sub-group name, not by rank, so a slice keeps its colour when the counts
  // shift. "Unspecified" is grey because it marks missing data, not a taxon.
  const plantaeSubgroupColors = {
    Angiosperm: '#fce411',
    Gymnosperm: '#043d13',
    'Non-seed': '#04dba5',
    'Green algae': '#0be204',
    'Red algae': '#f10101',
    Unspecified: '#7d838a'
  };
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  function processStats(stats){
    const kingdomOccurence = groupKingdoms(stats.kingdomsCounts);
    const typesAndKingdoms = groupTypesAndKingdoms(stats.terpeneTypesByKingdomCount);
    const aaFreq = calculateAminoAcidFrequency(stats.sequences)
    stats.kingdomOccurence = kingdomOccurence;
    stats.plantaeSubgroups = groupPlantaeSubgroups(stats.kingdomsCounts);
    stats.speciesByKingdom = groupSpeciesByKingdom(stats.speciesKingdoms);
    stats.groupedTypesKingdoms = typesAndKingdoms[0];
    stats.kingdoms = typesAndKingdoms[1]; 
    stats.aaFreq = aaFreq;
    const stepCounts = stats.mechanismLengths.map(m => m.step_count);
    const averageStepCount = stepCounts.reduce((sum, value) => sum + value, 0) / stepCounts.length;
    const stepCountVariance = stepCounts.reduce((sum, value) => sum + Math.pow(value - averageStepCount, 2), 0) / stepCounts.length;
    const stepCountStdDev = Math.sqrt(stepCountVariance);
    stats.averageStepCount = Math.round((averageStepCount + Number.EPSILON) * 100) / 100
    stats.stepCountStdDev = Math.round((stepCountStdDev + Number.EPSILON) * 100) / 100
    stats.mechanismStepLengths = stats.mechanismLengths.map(m => m.step_count).sort((a, b) => a - b);
    const enzymeHistory = computeEnzymeHistory(stats.enzymeHistory);
    stats.enzymeGrowth = enzymeHistory.series;
    stats.enzymeGrowthBaseline = enzymeHistory.baseline;
    return stats;
  }

   async function loadStats() {
      const stats = await axios.post("/statspage");
      const updatedStats = processStats(stats.data);
      setStats(updatedStats);
      console.log(stats);
      console.log(updatedStats);
    }

    useEffect(() => {
        loadStats();
      }, []);

      if (!stats) {
        return(
          <div id="statsbody">
          <HomeNavbar />
          <div id="statspage">
              <h1>Marts-DB statistics</h1>
        <StatsBox title={"Loading statistics..."}>
          <SmallLoading />
          </StatsBox>
          </div>
          <Footer /> 
          </div>)  
      }
    return (
        <div id="statsbody">
        <HomeNavbar />
        <PageMenu>
        <h1>Marts-DB statistics</h1>
        <StatsBox title={"Basics"}>
          <p>Marts-DB is a database of terpene synthases, their reactions and reaction mechanisms. </p>
          <InfoTable data = {[["Type", "Enzymes", "Reactions catalyzed", "Products", "Substrates", "Unique mechanisms", "Kingdoms", "Species"],
          ["Number of entries", stats.enzymeCount[0].enzymeCount, stats.reactionCount[0].reactionCount, stats.productCount[0].productCount, stats.substrateCount[0].substrateCount, stats.mechanismCount[0].mechanismCount, stats.kingdomOccurence.length, stats.speciesCount.length]]}/>

         </StatsBox>

        <StatsBox title={"Enzymes"}> 
        <StatsBox title={"Taxonomic origin"}>
          <div className="stats-layout">
            <div className="stats-table">
            <InfoTable data={[["Kingdom"].concat(stats.kingdomOccurence.map(k => k.kingdom)), ["Number of enzymes"].concat(stats.kingdomOccurence.map(k => k.occurrence_count))]} /> 
            </div>
            <div className="stats-chart">
              <Chart chartType="PieChart" width="100%" height="400px" data={[["Kingdom", "Enzymes"]].concat(stats.kingdomOccurence.map(k => [k.kingdom, k.occurrence_count]))}
              options={{
                title: "Distribution of enzymes by kingdom",
                pieSliceText: "label",
                // Keyed by kingdom name, not by slice position, so every kingdom
                // keeps the same colour here as in the species-per-kingdom and
                // types-by-kingdom charts below.
                slices: stats.kingdomOccurence.map((k, index) => ({ color: kingdomColors[k.kingdom] || colors[index % colors.length] })),
                // Default threshold (0.5 %) would fold the smallest kingdoms
                // (Archaea, Viruses, Stramenopila) into an unnamed "Other" slice
                // and shift the slice indices the colours are matched on.
                sliceVisibilityThreshold: 0,
                legend: { position: "bottom" },
                chartArea: { left: 10, top: 40, width: "92%", height: "75%" },
                height: 400
              }}/>
        {/*<ResponsiveContainer width="100%" height="100%">
        <PieChart width={400} height={400}>
        <Pie
            dataKey="occurrence_count"
            nameKey="kingdom"
            data={stats.kingdomOccurence}
            cx="50%"
            cy="50%"
            outerRadius="100%"
            labelLine={false}
            label={renderCustomizedLabel}
          >
          {stats.kingdomOccurence.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
        </Pie>
        <Legend />
        </PieChart>
        </ResponsiveContainer>*/}
            </div>  
          </div>
          {stats.plantaeSubgroups.length > 0 && (
            <>
              <h2 className="stats-title">Plantae categories</h2>
              <div className="stats-layout">
                <div className="stats-table">
                  <InfoTable data={[["Sub-group"].concat(stats.plantaeSubgroups.map(p => p.subgroup)), ["Number of enzymes"].concat(stats.plantaeSubgroups.map(p => p.occurrence_count))]} />
                </div>
                <div className="stats-chart">
                  <Chart chartType="PieChart" width="100%" height="400px"
                    data={[["Sub-group", "Enzymes"]].concat(stats.plantaeSubgroups.map(p => [p.subgroup, p.occurrence_count]))}
                    options={{
                      title: "Distribution of Plantae enzymes by sub-group",
                      pieSliceText: "percentage",
                      // Pinned white: the ramp's dark greens need light text and
                      // every step clears 3:1 against white.
                      pieSliceTextStyle: { color: "white" },
                      // Default threshold (0.5 %) would silently merge the small
                      // sub-groups into an "Other" slice; keep every one visible.
                      sliceVisibilityThreshold: 0,
                      slices: stats.plantaeSubgroups.map((p, index) => ({ color: plantaeSubgroupColors[p.subgroup] || colors[index % colors.length] })),
                      legend: { position: "bottom" },
                      chartArea: { left: 10, top: 40, width: "92%", height: "75%" },
                      height: 400
                    }} />
                </div>
              </div>
            </>
          )}
          <h2></h2>
          <h2 className="stats-title">Represented species: {stats.speciesCount.length}</h2>
          <div className="stats-layout">
             <div className="stats-table">
            <InfoTable data={[["Most represented species"].concat(stats.speciesCount.slice(0,10).map(s => s.species)), ["Number of enzymes"].concat(stats.speciesCount.slice(0,10).map(s => s.occurrence_count))]} />
            </div>
            <div className="stats-table">
            <InfoTable data={[["Most represented species"].concat(stats.speciesCount.slice(10,20).map(s => s.species)), ["Number of enzymes"].concat(stats.speciesCount.slice(10,20).map(s => s.occurrence_count))]} />
            </div>
          </div>
          <h2 className="stats-title">Unique species per kingdom</h2>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={stats.speciesByKingdom}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="kingdom" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="species_count" name="Unique species">
                {stats.speciesByKingdom.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={kingdomColors[entry.kingdom] || colors[index % colors.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </StatsBox>
        <StatsBox title = {"Distribution of enzymes by terpene types and kingdom"}>
          <p>Based on the length of the substrate, terpenes are divided into types. Hemi terpenes contain five carbons, mono terpenes ten, sesquiterpenes fifteen and so on. Isoprenyl diphosphate synthases are abbreviated as 'pt', squalene synthases as 'sqs' and phytoene synthases as 'psy'.
            Enzymes that catalyze reaction of multiple terpene types are counted in all relevant categories.
          </p>
          <ResponsiveContainer width="100%" height={400}>
          <BarChart
          data={stats.groupedTypesKingdoms}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="type" />
          <YAxis />
          <Tooltip />
          <Legend />
          {stats.kingdoms.map((group, index) => (
            <Bar key={group} dataKey={group} stackId="a" fill={kingdomColors[group]} />
          ))}
        </BarChart></ResponsiveContainer>
        </StatsBox>
        <StatsBox title={"Aminoacid frequency"}>
          <div className="stats-layout">
            <div className="stats-table">
            <InfoTable data={[["Aminoacid"].concat(stats.aaFreq.map(i => i.aa)), ["Frequency"].concat(stats.aaFreq.map(i => i.freq))]} />
            </div>
            <div className="stats-chart">
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={stats.aaFreq}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="aa" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="freq" fill="#173797" activeBar={<Rectangle fill="#173797" stroke="blue" />} />
                </BarChart>
              </ResponsiveContainer>
              </div>
          </div>
        </StatsBox>
        </StatsBox>

        <StatsBox title={"Terpenes"}>
          <StatsBox title={"Distribution by terpene types by unique products"}>
            <div className="stats-layout">
            <div className="stats-table">
            <InfoTable data={[["Type"].concat(stats.terpenesByType.map(t => t.type)), ["Number of unique products"].concat(stats.terpenesByType.map(t => t.terpene_count))]} />
            </div>
            <div className="stats-chart">
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={stats.terpenesByType}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="type" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="terpene_count" fill="#173797" activeBar={<Rectangle fill="#173797" stroke="blue" />} />
                </BarChart>
              </ResponsiveContainer>
              </div>
            </div>
          </StatsBox>
          <StatsBox title={"Substrates by number of reactions"}>
          <div className="stats-layout">
             <div className="stats-table">
            <InfoTable data={[["Substrate"].concat(stats.substratesOccurence.slice(0,Math.ceil(stats.substratesOccurence.length/2)).map(s => s.name)), ["Number of reactions"].concat(stats.substratesOccurence.slice(0,Math.ceil(stats.substratesOccurence.length/2)).map(s => s.substrate_count))]} />
            </div>
            <div className="stats-table">
            <InfoTable data={[["Substrate"].concat(stats.substratesOccurence.slice(Math.ceil(stats.substratesOccurence.length/2),stats.substratesOccurence.length).map(s => s.name)), ["Number of reactions"].concat(stats.substratesOccurence.slice(Math.ceil(stats.substratesOccurence.length/2),stats.substratesOccurence.length).map(s => s.substrate_count))]} />
            </div>
          </div>
          </StatsBox>
        </StatsBox>
        <StatsBox title={"Mechanisms"}>
          <p>Mechanisms are divided into steps, every step has its type.</p>
          
          <ResultInfoText text={`Average number of steps per mechanism is ${stats.averageStepCount} (std ${stats.stepCountStdDev}), longest mechanism length: ${Math.max(...stats.mechanismStepLengths)}`  } fontSize="20px" row={1} buttonClass="plane-text-button-no-background"/>
          <Chart
      chartType="Histogram"
      data={[
        ["Step count"],
         ...stats.mechanismStepLengths.map(length => [length]),
      ]}
      options={{
        title: "Distribution of the numbers of steps",
        bucketSize: 1,
        hAxis: {
          title: "Length of mechanism in steps",
        },
        vAxis: {
          title: "Frequency",
        },
        colors: ["#173797"],
      }}    
    />
          <StatsBox title={"Distribution of step types for unique mechanism steps"}>
            <div className="stats-layout">
            <div className="stats-table">
            <InfoTable data={[["Step type"].concat(stats.mechanismStepsCount.map(t => t.mechanism_type)), ["Number of occurrences"].concat(stats.mechanismStepsCount.map(t => t.mechanismStepsCount))]} />
            </div>
            <div className="stats-chart">
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={stats.mechanismStepsCount}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="mechanism_type" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="mechanismStepsCount" fill="#173797" activeBar={<Rectangle fill="#173797" stroke="blue" />} />
                </BarChart>
              </ResponsiveContainer>
              </div>
            </div>
          </StatsBox>
        </StatsBox>

        <StatsBox title={"History"}>
          <p>Growth of the number of enzyme entries in MARTS-DB over time. The baseline is the
            initial database upload.</p>
          {stats.enzymeGrowth.length > 0 && (
            <ResponsiveContainer width="100%" height={400}>
              <AreaChart
                data={stats.enzymeGrowth}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="ts" type="number" scale="time" domain={['dataMin', 'dataMax']}
                  tickFormatter={(ts) => new Date(ts).toISOString().slice(0, 7)} minTickGap={30} />
                <YAxis domain={[(dataMin) => Math.max(0, dataMin - 20), (dataMax) => dataMax + 10]} allowDecimals={false} />
                <Tooltip labelFormatter={(ts) => new Date(ts).toISOString().slice(0, 10)} />
                <ReferenceLine y={stats.enzymeGrowthBaseline} stroke="#b24502" strokeDasharray="4 4"
                  label={{ value: "Initial upload", position: "insideBottomLeft", fill: "#b24502" }} />
                <Area type="stepAfter" dataKey="count" name="Enzyme entries" stroke="#173797" fill="#173797" fillOpacity={1} />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </StatsBox>
      </PageMenu>
        <Footer />
        </div>      
        );



}

export default Statistics;
